import StubPage from '../../components/StubPage.jsx';

export default function IntegrationsPage() {
  return (
    <StubPage
      title="Integrations & extensions"
      description="Apps, APIs, and webhooks that plug Pubvora into the rest of your stack."
      planned={[
        'App marketplace with one-click install',
        'Public REST API + scoped API tokens',
        'Webhook subscriptions for site, page, order, and user events',
        'First-party Zapier, Make, and n8n connectors',
      ]}
    />
  );
}
